<script lang="ts">
  import { NavLink } from '@shared/ui/nav-link';

  import { navigationLinksStore } from '@features/navigation';
</script>

<ul class="flex items-center gap-9 lg:gap-5 xl:gap-6">
  {#each $navigationLinksStore as { title, link }}
    <li>
      <NavLink props="{{ href: `${link}/`, class: 'font-medium text-[15px]' }}">
        {title}
      </NavLink>
    </li>
  {/each}
</ul>
